export const hasCommercialAmendment = (order) => Number(order?.amendmentRevision || 0) > 0;

export const getCommercialOrderSource = (order = {}) => {
  const value = String(order.source || order.salesChannel || '').trim().toLowerCase().replace(/_/g, '-');
  if (['whatsapp', 'zap', 'brutos-zap', 'cardapio', 'cardapio-digital', 'foody', 'autozap'].includes(value)) return 'site';
  if (['brutos', 'orders', 'brutos-orders', 'manual', 'local'].includes(value)) return 'brutos-orders';
  return ['ifood', 'site', 'balcao', 'salao', 'pedidos10'].includes(value) ? value : '';
};

export const getCommercialTotal = (order = {}) => {
  const total = hasCommercialAmendment(order) && !order.commercialConflict
    ? order.total : order.fullOrderData?.total || order.total;
  return total && typeof total === 'object' ? total : { orderAmount: Number(total || 0) };
};

export const getCommercialPayments = (order = {}) => hasCommercialAmendment(order) && !order.commercialConflict
  ? order.payments || {}
  : order.fullOrderData?.payments || order.payments || {};

export const getAmendmentCollectionMethod = (order = {}) => {
  if (!hasCommercialAmendment(order)) return null;
  const payments = getCommercialPayments(order);
  if (Number(payments.totalDue || 0) <= 0) return null;
  const pending = (Array.isArray(payments.methods) ? payments.methods : []).filter((method) => (
    Number(method.amountDue ?? (method.prepaid === false ? method.amount ?? method.value : 0)) > 0
  ));
  return (pending.find((method) => method.collectionResponsibility !== 'merchant') || pending[0])?.method || payments.paymentMethod || null;
};

export const getAmendmentPrintIdentity = (order = {}, revision = order.amendmentRevision) => ({
  ...order,
  _printRevision: Number(revision),
});
